module.exports = __webpack_public_path__ + "img/staff-photo-2.e1a22d9.png";